import { supabase } from "@/integrations/supabase/client";

export const GSC_REDIRECT_PATH = "/gsc-callback";

export const buildGscRedirectUri = () =>
  `${window.location.origin}${GSC_REDIRECT_PATH}`;

/**
 * Starts the GSC-only OAuth flow.
 * IMPORTANT: This does NOT call supabase.auth.signInWithOAuth, so the user's
 * Supabase login session is preserved. The Google OAuth URL (with client ID)
 * is built server-side by the start-gsc-oauth edge function so the client ID
 * never ships to the frontend.
 */
export async function startGscOAuth() {
  const { data: auth } = await supabase.auth.getUser();
  const uid = auth.user?.id;
  if (!uid) throw new Error("You must be logged in to connect Google Search Console.");

  const redirectUri = buildGscRedirectUri();
  const { data, error } = await supabase.functions.invoke("start-gsc-oauth", {
    body: { redirectUri },
  });

  const payload: any = data;
  if (error || !payload?.ok || !payload?.url) {
    throw new Error(payload?.error || error?.message || "Could not start GSC OAuth flow.");
  }

  window.location.href = payload.url;
}
